export default __webpack_public_path__ + "static/media/man.4b61dde6.png";